import React from "react";
import { Hidden, Typography } from "@material-ui/core";
import { BUSINESS } from "routes/paths";
import { PRIORITY_WEBSITE } from "utils/urls";
import Item from "./Item";
import usePathListener from "hooks/usePathListener";

const LINKS = [
  {
    title: "PERSONAL",
    link: "/",
    type: "Internal",
  },
  {
    title: "BUSINESS",
    link: BUSINESS,
    type: "Internal",
  },
  {
    title: "PRIORITY",
    link: PRIORITY_WEBSITE,
    type: "External",
  },
];

const Separator = () => {
  return (
    <Typography
      color="primary"
      variant="body1"
      style={{
        margin: "0 15px",
        borderBottom: "5px solid transparent",
      }}
    >
      <strong>|</strong>
    </Typography>
  );
};
const NavQuickLinks = () => {
  const { pathname } = usePathListener();
  return (
    <Hidden smDown>
      {LINKS.map((item, idx) => (
        <>
          <Item {...item} pathname={pathname} />
          {idx < LINKS.length - 1 && <Separator />}
        </>
      ))}
    </Hidden>
  );
};

export default NavQuickLinks;
